// หา array ที่ไม่ซ้ำกัน
// ex fn = (a, b) => a.id == b.id
export default function filterNonUniqueBy(arr, fn) {
    return arr.filter((v, i) => arr.every((x, j) => (i === j) === fn(v, x, i, j)));
}
